import React, { useEffect, useState, useRef} from 'react';
import { Link,useParams,useNavigate  ,useLocation} from 'react-router-dom';
import data from '../json/palette.json'
import API from "../API/api.js";
import { sendAnalyticsData } from '../utilities/analytics';
import Cookies from 'universal-cookie';

import Html5QrcodePlugin from '../components/QR'
import "../../node_modules/flag-icons/css/flag-icons.min.css";

const PageResult = () => {

  const { type } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [QRLogin, setQRLogin] = useState(false);
  const [isTryLogin, setisTryLogin] = useState(false);

  const [isTryRegister, setisTryRegister] = useState(false);
  const prevIsTryLogin = useRef(isTryLogin);
  const prevIsTryRegister = useRef(isTryRegister);
  const [loginCode, setloginCode] = useState(false)
  const [isStopCommand, setisStopCommand] = useState(false);
  const [isSuccessLogin, setisSuccessLogin] = useState(false);
  const [qrReaded, setqrReaded] = useState(false);
  const [result, setResult] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  // const [btnDisabled, setbtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [textLoading, setTextLoading] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [errorConnection, setErrorConnection] = useState(false);
  const [errorText, setErrorText] = useState(false);

  const [toast, setToast] = useState({ show: false, message: '' });
  const toastTimerRef = useRef(null);

  const [isPhoneNumber,setIsPhoneNumber]= useState('nonfocus')
  const [isEmail,setIsEmail]= useState('nonfocus')
  const [isName,setIsName]= useState('nonfocus')
  const [phoneCode,setPhoneCode] = useState('+62')

  
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(false);
  const [showKeypad, setShowKeypad] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const handleCheckboxChange = () => {
    if(isPhoneNumber==='true'&& isEmail==='true' && isName==='true')
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    if (isSuccessLogin)
    {
      setisStopCommand(true);
      setqrReaded(true);
    }
  }, [isSuccessLogin]);

  useEffect(() => {
    return () => {
      if (toastTimerRef.current) {
        clearTimeout(toastTimerRef.current);
      }
    };
  }, []);

  // useEffect(() => {
  //   if (!location.state) {
  //     navigate('/')
  //   }
  // }, [location.state]);

  useEffect(() => {
    if (location?.state?.photo) {
      setisStopCommand(true);
      submitEmail(formData);
    }
  }, [location?.state?.photo]);

  useEffect(() => {
    if (!isTryLogin) {
      prevIsTryLogin.current = false;
      return;
    }

    if (prevIsTryLogin.current) return;

    prevIsTryLogin.current = true;
    tryLogin(loginCode);
  }, [isTryLogin, loginCode]);

  
  useEffect(() => {
    if (!isTryRegister) {
      prevIsTryRegister.current = false;
      return;
    }

    if (prevIsTryRegister.current) return;

    prevIsTryRegister.current = true;
    tryRegister(formData);
  }, [isTryRegister]);

  function checkComplexionName(color){
    let complexionNameArr = data.complexion_name
    return complexionNameArr[color]
  }

  function showToast(message, duration = 3000) {
    if (toastTimerRef.current) {
      clearTimeout(toastTimerRef.current);
    }
    setToast({ show: true, message });
    toastTimerRef.current = setTimeout(() => {
      setToast({ show: false, message: '' });
    }, duration);
  }

async function tryLogin(code) {
  if (isSuccessLogin) return;

  try {
    const res = await fetch(`https://colourintelligence.wardahbeauty.com/api/get_profile`, {
      method: "POST",
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: code,
        origin: "pca"
      })
    });

    const json = await res.json();

    if (json?.data?.user?.name) {
      setisSuccessLogin(true);
      setisTryLogin(false);

      const user = {
        name: json.data.user.name,
        email: json.data.user.email,
        phone: formatPhone(json.data.user.phone),
      };

      setFormData(user);
      setIsName('true');
      setIsEmail('true');
      setIsPhoneNumber('true');
    } else {
      setisSuccessLogin(false);
      setisTryLogin(false);
      showToast('User not found. Please check your QR code or register manually.');
    }
  } catch (error) {
    setisSuccessLogin(false);
    setisTryLogin(false);
    showToast('User not found. Please check your QR code or register manually.');
  }
}

  async function tryRegister(data)
  {
    setTextLoading(true);
    // await fetch(`https://skinanalyzer.wardahbeauty.com/api/register`, {
    // // await fetch(`https://192.168.31.125:3091/api/register`, {
    //   method:"POST",
    //   headers: {
    //     'Content-Type':'application/json'
    //   },
    //   body: JSON.stringify({
    //     origin: "pca",
    //     "name": data.name,
    //     "email": data.email,
    //     "phone": data.phone,
    //     "birthdate": null,
    //     "city": null,
    //     "gender": null,
    //     "isMarketingWA": isChecked ? 1 : 0,
    //     "isMarketingEmail": isChecked ? 1 : 0,
    //     "isPrivacyConsent": 1
    //   })
    // }).then(async res =>{
    //   let json = await res.json()
    //   if(json.status)
    //   {
        // setTextLoading(false);
        // setloginCode(json.data.paragon_code)
        navigate(location?.state?.photo ? `/expert/captured` : `/expert/camera`, {
          state:{
            name: data.name,
            email: data.email,
            phone: data.phone,
            qrCode: loginCode
          }
        });
        setisTryRegister(false);
    //   }
    //   if(json.error)
    //   {
    //     setisSuccessLogin(false)
    //     setisTryRegister(false)
    //     console.log(json.data.errors[0].includes('already'))
    //     if(json.data.errors[0].includes('already')){
    //       setErrorText('Phone number is already registered!')
    //     }else{
    //       setErrorText('We are in high demand, please try again!')
    //     }

        // setTextLoading(false);
        // setErrorSubmit(true);
    //   }
    // })
  }

  function onNewScanResult(decodedText, result)
  {
    if(decodedText && decodedText != null && decodedText != undefined)
    {
      if(isTryLogin || isSuccessLogin)
        return
      setisTryLogin(true)
      setloginCode(decodedText)
    }
    return;
  }
  function onNoScanResult()
  {
    return;
  }
  function onChangeForms()
  {
    if(isTryLogin || isTryRegister)
    return;

    const switchingToQRView = !QRLogin;
    setQRLogin(!QRLogin);

    if (switchingToQRView) {
      // Reset scanner-blocking flags so the QR camera actually restarts
      setisStopCommand(false);
      setqrReaded(false);
      setisSuccessLogin(false);
      setisTryLogin(false);
      setloginCode(false);
    }
  }

  function handleRegister(){
    onChangeForms();
  }

  async function submitEmail(data){
    // setResult(true);
    try {
      setIsLoading(true);
      setErrorSubmit(false);
      setErrorConnection(false);
      setErrorText('');

      const cookies = new Cookies();
      let event_source = cookies.get('event_name') || 'BST 2026';

      if(document.body.clientWidth <= 480){ //mobile
        event_source = '';
      }

      // const ApiResult = 'https://api.wardah-colourintelligence.com/detect/submit';
      const ApiResult = 'https://api-colourintelligence.wardahbeauty.com/detect/submit';

      var payload = {
        'name': location.state.name || data?.name,
        'email': location.state.email || data?.email,
        'phone': location.state.phone || data?.phone,
        'event_name': event_source,
        'photo': location.state.photo
      }

      const FETCH_TIMEOUT_MS = 10000;
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

      fetch(ApiResult, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload),
        signal: controller.signal
        })
        .then((response) => response.json())
        .then((jsonData) => {
          clearTimeout(timeoutId);
          if (!jsonData.season) {
            setIsLoading(false);
            setErrorSubmit(true);
            return;
          }

          navigate(`/${type}/result-template`, {
            state:{
              photo: location.state.photo,
              name: location.state.name || data?.name,
              email: location.state.email || data?.email,
              qrCode: location?.state?.qrCode,
              phone: phoneCode.replace('+','') + (location.state.phone || data?.phone),
              subseasonal: jsonData.season,
              subseasonalAccuracy: jsonData.season_accuracy,
              subseasonalAlt: jsonData.season_alt,
              subseasonalAccuracyAlt: jsonData.season_alt_accuracy,
              complexionName: checkComplexionName(jsonData.skintone),
              skintone: jsonData.skintone,
            }
          })

          sendAnalyticsData('API Success','Submit Email')
          sendAnalyticsData('Click','Go To Result Template Page')
          // setResult(false);
      }).catch((err)  => {
        clearTimeout(timeoutId);
        if (err?.name === 'AbortError') {
          setErrorConnection(true);
          setErrorText("<strong class='d-block mb-2'>Connection Unstable</strong>We're having trouble connecting.<br>Please check your internet connection and try again.");
        } else {
          setIsLoading(false);
          setErrorSubmit(true);
        }
      })

      // return
    // }
    // console.log('failed send email');
    // return res
    } catch (error) {
      setIsLoading(false);
      if(error.message[0]==='Already submitted'){
        // localStorage.removeItem('fID')
        // console.log('next page')
        
        // return
      }
      sendAnalyticsData('API Failed','Submit Email')

      // navigate('/'+type+'/result-template')
    }
 
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setisTryRegister(true)
    // submitEmail(formData)
  };



  const handleClickOption = (e) => {
    setAutoCompleteOpen(false);
    
    // Get the selected domain
    const selectedDomain = e.target.innerText;

    // Update the email field with the selected domain
    setFormData((prev) => {
      // If the user already typed part of their email, keep it before the '@'
      let emailPrefix = prev.email.split("@")[0];
      return { ...prev, email: emailPrefix + selectedDomain };
    });
  };

const handleKeypadClick = (number) => {
  // Update phone number and validate it using handleChange
  setFormData((prev) => {
    const updatedPhone = formatPhone(prev.phone + number);
    // Call handleChange with the updated phone number
    handleChange({ target: { name: 'phone', value: updatedPhone } });
    return { ...prev, phone: updatedPhone };
  });
}

const handleDelete = () => {
  setFormData(prev => ({
    ...prev,
    phone: prev.phone.slice(0, -1)
  }));
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    const finalValue = name === 'phone' ? formatPhone(value) : value;

    setFormData({
      ...formData,
      [name]: finalValue,
    });
    if(name==='email'){
      if(!regexEmail(value)){
        setIsChecked(false)
        setIsEmail('false')
        return
      }else{
        setIsEmail('true')
      }
    }
    if(name==='phone'){
      if(!regexPhone(finalValue)){
        setIsChecked(false)
        setIsPhoneNumber('false')
        return
      }else{
        setIsPhoneNumber('true')
      }
    }
    if(name==='name'){
      if(!regexName(value)){
        setIsChecked(false)
        setIsName('false')
        return
      }else{
        setIsName('true')
      }
    }
  };
  const regexEmail=(email)=>{
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)
  }
  const formatPhone = (phone) => {
    if (!phone) return phone;
    // leave 08, 62, and +62 prefixed numbers as typed — no forced leading 0
    return phone;
  };
  const regexPhone=(phone)=>{
    // accepts numbers starting with 08, 62, or +62
    return /^(\+62|62|08)[1-9][0-9]{6,10}$/.test(phone);
  }
  const regexName = (name)=>{
    return /^[a-zA-Z ]+$/.test(name)
  }
  
  const dropdownRef = useRef(null);
  const dropdownBtnRef = useRef(null);
  const togglePhoneDropdown = () => {
    const dom = dropdownRef.current;
    dom.classList.add('d-block');
    return;
  }
  const changePhoneCode = (code) => {
    const dom = dropdownRef.current;
    const btnDom = dropdownBtnRef.current;
    dom.classList.remove('d-block');
    btnDom.innerHTML = code;
    setPhoneCode(code);
    return;
  }
  return (
    <>
      {toast.show && (
        <div className='toast-notification'>
          <span className='toast-message'>{toast.message}</span>
        </div>
      )}
      <div className='container container-fluid container-loading-result'>
        <div className='full-height result-form-wrapper'>
          <div className='page-wrapper d-flex justify-content-center align-items-center flex-column text-center'>
          {isLoading ? 
            <>
              <div className='logo-form justify-content-center align-items-center w-100'>
                {/* <Link className='back page-back' onClick={() => navigate(-1)} style={{top: '45%', left: 'unset', left: '27px'}}>
                  <img className='icon-back' src='/images/icon-back.png' alt=''/>
                </Link> */}
                <img src='/images/logo.png' alt=''/>
              </div>
              <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center pb-4'>
                {
                  errorSubmit || errorConnection ? 
                    <></>
                  :
                    <>
                      <h3>please wait a moment..</h3>
                      <img className='loader-image' src='/images/loader.png' alt=''/>
                    </>
                }
                <div className='loading-result-title'>
                  <h2 className='mb-3'>{
                    errorConnection ?
                      <>
                        <p className='mt-3 mb-4'><span dangerouslySetInnerHTML={{ __html: errorText }} /></p>
                        <div className='btn btn-secondary' onClick={() => window.location.href = '/' }>
                          Try again
                        </div>
                      </>
                    : errorSubmit ?
                      <>
                        <p className='mt-3 mb-4'>We are in high demand, please try again!</p>
                        <div className='btn btn-secondary' onClick={() => window.location.href = '/' }>
                          Try again
                        </div>
                      </>
                    :
                      'Analyzing Your Personal Color'
                    }
                   </h2>
                </div>
              </div>
            </>
            :
            <>
              {QRLogin && !result && !qrReaded ? 
                <>
                  <div className='logo-form justify-content-center align-items-center w-100'>
                      <Link to={'/'} className='back page-back' style={{top: '45%', left: 'unset', left: '27px'}}>
                        <img className='icon-back' src='/images/icon-back.png' alt=''/>
                      </Link>
                    <img src='/images/logo.png' alt=''/>
                  </div>
                  <div className='form-result'>
                    <div className='form-result-inner'>
                      <h2 className='text-center'>Scan your QR Code</h2>
                      <Html5QrcodePlugin
                        fps={1}
                        qrbox={280}
                        aspectRatio={1}
                        disableFlip={true}
                        qrCodeSuccessCallback={onNewScanResult}
                        qrCodeErrorCallback={onNoScanResult}
                        stopCommand={isStopCommand}
                    />
                      <button className={`btn w-100 mt-3 button-register`} onClick={handleRegister} style={{maxWidth: 'unset'}} type='button'><span style={{color:"#000000", fontFamily: 'Montserrat Light'}}>Not registered? </span>Fill Form Here</button>
                    </div>
                  </div>
                </>
              :
                <>
                <div className='logo-form justify-content-center align-items-center w-100'>
                    <div role="button" className='back page-back' onClick={() => { setQRLogin(true); setqrReaded(false); setisStopCommand(false); setisSuccessLogin(false); setisTryLogin(false); setloginCode(false); }} style={{top: '45%', left: 'unset', left: '27px'}}>
                      <img className='icon-back' src='/images/icon-back.png' alt=''/>
                    </div>
                  <img src='/images/logo.png' alt=''/>
                </div>
                <form className='form-result' autoComplete="off" onSubmit={handleSubmit} >
                  <div className='form-result-inner'>
                    <h2>Personal Data</h2>
                    <div className='form-control-wrapper'>
                      <label className="form-label">Name</label>
                      <input className='form-control text-center' autoComplete="off" type="text" name='name' value={formData.name} onChange={handleChange} required/>
                      <p className={`error-validation ${isName === 'false' ? 'opacity-1' : 'opacity-0'}`}>Name must not be empty</p>
                    </div>
                    
                    <div className='form-control-wrapper'>
                      <label className="form-label">Email</label>
                      <input className='form-control text-center' autoComplete="off" type="email" name='email' value={formData.email} required 
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })} 
                        onKeyUp={() => setAutoCompleteOpen(true)} 
                        onBlur={(e) => setTimeout(() => {setAutoCompleteOpen(false); handleChange(e)}, 200)} // Delay closing to allow click
                      />
                      {autoCompleteOpen && (
                        <div className="input-autocomplete open">
                          <p onClick={handleClickOption}>@gmail.com</p>
                          <p onClick={handleClickOption}>@yahoo.com</p>
                          <p onClick={handleClickOption}>@msn.com</p>
                          <p onClick={handleClickOption}>@live.com</p>
                        </div>
                      )}
                      <p className={`error-validation ${isEmail === 'false' ? 'opacity-1' : 'opacity-0'}`}>Email is not valid</p>
                    </div>

                    <div className='form-control-wrapper'>
                      <label className="form-label">No Handphone</label>
                    
                      <input className='form-control text-center' autoComplete="off" type="text" name='phone' value={formData.phone} onClick={() => setShowKeypad(true)} onChange={handleChange} required
                      readOnly={ document.body.clientWidth > 1024 && document.body.clientHeight > 1366 }/>
                      {showKeypad && (
                        <div className="keypad">
                          {[...'1234567890'].map(num => (
                            <button key={num} type="button" onClick={() => handleKeypadClick(num)}>
                              {num}
                            </button>
                          ))}
                          <button type="button" onClick={handleDelete}>&larr;</button>
                          <button type="button" onClick={() => setShowKeypad(false)}>OK</button>
                        </div>
                      )}
                      <p className={`error-validation ${isPhoneNumber === 'false' ? 'opacity-1' : 'opacity-0'}`}>Phone number is not valid</p>
                    {/* </div> */}
                    </div>

                    <label className='checkbox'>
                      <input
                        name='tnc2'
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      I agree to receive personalized commercial communications from Wardah
                    </label>
                    

                    {!textLoading || errorSubmit ?
                      qrReaded ? (
                        <Link
                          to={`/expert/captured`}
                          state={{
                            name: formData.name,
                            email: formData.email,
                            phone: formData.phone,
                            qrCode: loginCode
                          }}
                          className={`btn btn-secondary w-100 d-table mx-auto text-center ${!isChecked ? 'disabled' : ''}`}
                          style={{maxWidth: 'unset'}}
                        >
                          Next
                        </Link>
                      ) : (
                        <Link
                          to={`/expert/captured`}
                          state={{
                            name: formData.name,
                            email: formData.email,
                            phone: formData.phone,
                            qrCode: loginCode
                          }}
                          className={`btn btn-secondary w-100 d-table mx-auto text-center ${!isChecked ? 'disabled' : ''}`}
                          style={{maxWidth: 'unset'}}
                        >
                          Next
                        </Link>
                      )
                      :
                      null
                    }
                    

                    {textLoading && !errorSubmit?
                      <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center mt-2'>
                        <img className='loader-image' src='/images/loader.png' alt=''/>
                      </div>
                      :
                      null
                    }

                    {errorSubmit ? 
                      <div className='loading-result-intro d-flex flex-column align-items-center justify-content-center mt-3'>
                        <p className='text-danger text-center' style={{fontSize: '13px'}}>{errorText}</p>
                      </div>
                      :
                      null
                    }
                    <button className={`btn w-100 mt-2 button-register`} onClick={onChangeForms} style={{maxWidth: 'unset'}} type='button'>
                      <span style={{color:"#000000", fontFamily: 'Montserrat Light'}}>Already registered? </span>Scan QR Here
                    </button>
                  </div>
                </form>
              </>
              }
            </>
          }
          </div>
        </div>
        <img className='powered-logo position-absolute' src='/images/pixielab.png'/>
      </div>
    </>
  );
};

export default PageResult;